import { call, put, takeLatest } from "redux-saga/effects";
import {
  getAllLinkedItemsAction,
  getAllRoomListAction,
  getAllSurveyedItemsAction,
  getAllSurveyedSummaryAction,
  setAllLinkedItemsAction,
  setAllRoomListAction,
  setAllSurveyedItemsAction,
  setAllSurveyedSummaryAction,
  setUpdateSurveySummaryAction,
  setUpdateSurveyTabAction,
  updateSurveySummaryAction,
  updateSurveyTabAction,
  startSurveyAction,
  getCompleteSurveySummaryAction,
  setCompleteSurveySummaryAction,
  setIsGetSurveyedItemsAction,
  cancelSurveyAction,
  setCancelSurveyAction,
  updateSurveyTooltipAction,
  setSurveyTooltipsAction,
  setPropertyTypeAction,
} from "../reducers/leadSurveySlice";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { getAllLeadListAction, setSingleLeadAction, setUpdateLeadAction } from "../reducers/leadSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllRoomListSaga(action: {
  type: string;
  payload: { page: number; limit: number; orderBy: string; orderIn: string,leadID:any,role:any };
}): any {
  yield put(setLoaderAction(true));
  console.log("action?.payload-", action?.payload);
  const { leadID, role } = action?.payload;
  try {
     let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/${leadID}/room-items`;
      }else {
        url = `surveys/${action?.payload}/rooms-items`;
      }
    }
    const lead = yield call<any>(
      callAPI,
      action.payload,
      "get",
      url
    );
    console.log("lead-", lead);
    if (lead?.data) {
      yield put(setAllRoomListAction(lead?.data?.rooms));
      yield put(setPropertyTypeAction(lead?.data?.property_types));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* updateSurveyTabSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload--", payload);
  const { tab, data, surveyId } = payload?.payload;
  try {
    let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/${surveyId}?tab=${tab}`;
      }else {
        url = `surveys/${surveyId}?tab=${tab}`;
      }
    }
    const lead = yield call<any>(
      callAPI,
      { payload: data },
      "post",
      url
    );
    console.log("lead-", lead);
    if (lead?.success) {
      // yield put(setAllRoomListAction(lead?.data?.rooms));
      yield put(setUpdateSurveyTabAction(true));
      yield put(setIsGetSurveyedItemsAction(true));
      lead && handleSuccess(lead);
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
     error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getAllSurveyedItemsSaga(payload: any): any {
  yield put(setLoaderAction(true));
  console.log("payload-i-", payload);
  const { surveyID, role } = payload?.payload;
  try {
    let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/${surveyID}?query=get-items`;
      }else {
        url = `surveys/${payload?.payload}?query=get-items`;
      }
    }
    const lead = yield call<any>(
      callAPI,
      {},
      "get",
      url
    );
    console.log("lead-", lead);
    if (lead?.data) {
      yield put(setAllSurveyedItemsAction(lead?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* startSurveySaga(payload: any): any {
  yield put(setLoaderAction(true));
  console.log("payload-i-", payload);
  try {
    const lead = yield call<any>(
      callAPI,
      {},
      "get",
      `surveys/${payload?.payload}?query=start-survey`
    );
    console.log("lead-", lead);
    if (lead?.success) {
      yield put(setIsGetSurveyedItemsAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* getAllLinkedItemsSaga(): any {
  yield put(setLoaderAction(true));
  try {
    let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/linked-items`;
      }else {
        url = `surveys/linked-items`;
      }
    }
    const lead = yield call<any>(callAPI, {}, "get", url);
    console.log("lead-", lead);
    if (lead?.data) {
      yield put(setAllLinkedItemsAction(lead?.data?.list));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* getAllSurveyedSummarySaga(payload: any): any {
  yield put(setLoaderAction(true));
  console.log("payload-i-", payload);
  try {
     let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/${payload?.payload}?query=get-lead`;
      }else {
        url = `surveys/${payload?.payload}?query=get-lead`;
      }
    }
    const summary = yield call<any>(
      callAPI,
      {},
      "get",
      url
    );
    console.log("summary-", summary);
    if (summary?.data) {
      yield put(setAllSurveyedSummaryAction(summary?.data));
     
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* updateSurveySummarySaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload--", payload);
  const { surveyId,lift_availability,purchase_status,is_postcode_verified,volumeUnit, ...newPayload } = payload?.payload;
  console.log("newPayload-", newPayload);
  try {
     let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/${surveyId}?tab=tab4`;
      }else {
        url = `surveys/${surveyId}?tab=tab4`;
      }
    }

    const lead = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      url
    );
    console.log("lead-", lead);
    if (lead?.success) {
      lead && handleSuccess(lead);
      yield put(setUpdateSurveySummaryAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCompleteSurveySummarySaga(payload: any): any {
  yield put(setLoaderAction(true));
  console.log("payload-i-", payload);
  try {
     let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/surveys/${payload?.payload}?query=complete-survey`;
      }else{
        url = `surveys/${payload?.payload}?query=complete-survey`;
      }
    }
    const summary = yield call<any>(
      callAPI,
      {},
      "get",
      url
    );
    console.log("summary-", summary);
    if (summary?.success) {
      summary && handleSuccess(summary);
      yield put(setUpdateLeadAction(true));
      yield put(setCompleteSurveySummaryAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* cancelSurveySaga(payload: any): any {
  yield put(setLoaderAction(true));
  console.log("payload-i-", payload);
  try {
    const { type,generated_id,survey_id } = payload?.payload;
    let url: any = ""
    let method: any = "";

    if(type === "Surveyor") {
      url = `surveys/${survey_id}/cancel-survey`;
      method = "PUT";
    } else {
      url = `leads/${generated_id}/assign-surveyor?action=cancel`;
      method = "POST";
    }

    const lead = yield call<any>(
      callAPI,
      {},
      method,
      url
    );
    console.log("lead-", lead);
    if (lead?.success) {
      lead && handleSuccess(lead);
      yield put(setCancelSurveyAction(true));
      yield put(
        getAllLeadListAction({
          page: 1,
          limit: 10,
          orderBy: "created_at",
          orderIn: "DESC",
          search: "",
          roleType:type === "Surveyor" ? "Surveyor" : "Admin"
        })
      );
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response?.data)
    yield put(setCancelSurveyAction(false));
  }
  yield put(setLoaderAction(false));
}

function* updateSurveyTooltipSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "put",
      `surveys/${payload?.payload}/disable-tooltip`
    );
   
    if (res?.success) {
      res && handleSuccess(res);
      yield put(setSurveyTooltipsAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
     error?.response && handleError(error?.response?.data)
    yield put(setSurveyTooltipsAction(false));
  }
  yield put(setLoaderAction(false));
}
  

export function* watchLeadSurvey() {
  yield takeLatest<any>(getAllRoomListAction, getAllRoomListSaga);
  yield takeLatest<any>(updateSurveyTabAction, updateSurveyTabSaga);
  yield takeLatest<any>(getAllSurveyedItemsAction, getAllSurveyedItemsSaga);
  yield takeLatest<any>(getAllLinkedItemsAction, getAllLinkedItemsSaga);
  yield takeLatest<any>(startSurveyAction, startSurveySaga);
  yield takeLatest<any>(getAllSurveyedSummaryAction, getAllSurveyedSummarySaga);
  yield takeLatest<any>(updateSurveySummaryAction, updateSurveySummarySaga);
  yield takeLatest<any>(
    getCompleteSurveySummaryAction,
    getCompleteSurveySummarySaga
  );
  yield takeLatest<any>(cancelSurveyAction, cancelSurveySaga);
  yield takeLatest<any>(updateSurveyTooltipAction, updateSurveyTooltipSaga);
}
